module.exports = __webpack_public_path__ + "img/castle.fd247929.svg";